export const environment = {
    production: true,
    accopeningUserPassAuthCheck: new Map([
        [
            'CLIENTWEB',
            [
                ['accOpeningUsername', 'ZavQiciaB5nsaRMMae85I6FcZQH6pElWBqXLM9cbEAw='], //accOpeningUsername
                ['accOpeningPassWord', 'Z0ZeQ7BXlRQ2caMze7qsmlq+tcq8S5cxQJMPmZaCaSE='], //accOpeningPassWord
                ['AuthrizationKey', 'casam3zeve4afgeqdxfeb8fce220212121'], //AuthrizationKey
                // ['checkSumKey', '40817ZXag@Exzheo!9477'] //checkSumKey  40416ZBag@Qxzheo!9477 UAT
                ['checkSumKey', '98mCaLsItEeTrW1E8B022024!CC'] //live
            ]
        ],
        [
            'PWAWEB',
            [
              [
                'accOpeningUsername',
                'fGusa4I9qB5CbxwTiyGnYrNM5AZRQldHE0F+8SybGM76oqdLpuHFia1WQy4h+EyoOkVGPsEF82UweV7DKo86VtwXX4UKCvUhJa0SahIauQLZDW5IPhUWggFykU8UZnXA',
              ],
              [
                'accOpeningPassWord',
                'h32Qopziz9le4arLRo+fKgIdMV94M4fVmqdW858i8h+oh6ivGThlTCuz2jCWdi3r1qMjmqwMOgXKbBrlMtacWU0i3kS6H91EpIeZW3TEJBSVadfRDwH47umZqYLUSbAs',
              ],
              ['AuthrizationKey', 'Pasam3asrt6WEasakfksd9sRpWA0603024'],
              ['checkSumKey', '60324AGbd@Ashajf!8769'],
            ],
          ],
        [
            'SPOT',
            [
                ['accOpeningUsername', 'ix2OYeXODrPZukzBqyrfyspPmYlua530jU5o3thLftk='],
                ['accOpeningPassWord', '0YgAtI4tdAdkb6uqk9sbgLpn8kiYaqhZPGCJ+P4a8PI='],
                ['AuthrizationKey', 'XajPWfK6dLYQBYJ6r7tOghCzNF1brApV'],
                ['checkSumKey', 'fGpAd@w!N%@iMkKc']
            ]
        ],
        [
            'SPOTIOS',
            [
                ['accOpeningUsername', 'ix2OYeXODrPZukzBqyrfyspPmYlua530jU5o3thLftk='],
                ['accOpeningPassWord', '0YgAtI4tdAdkb6uqk9sbgLpn8kiYaqhZPGCJ+P4a8PI='],
                ['AuthrizationKey', 'YbkQXgL9eMbRaZK7s3uPkiDaMG2cdBrW'],
                ['checkSumKey', 'gHqBe@y!M%@jNlLd']
            ]
        ],
        [
            'PARTNERSHIPS',
            [
                ['accOpeningUsername', 'UoWJihikB1vjrQJKoj15L6VvCRH9pDlEBaKcY9SjEZw='],
                ['accOpeningPassWord', 'U5LeI7DQiPX1saTzw3nvqtg+lbd3R5jxQJYPiJaTaBE='],
                ['AuthrizationKey', 'PVbVNrbbcKcOd8UW2l2jVx8aTCYUOJeG'],
                ['checkSumKey', '1011P!BYQVNrbgmR62d8']
            ]
        ]
    ]),
    appVer: '1.0',
    osName: '5PWEB',
    // baseAPI: 'https://gateway.5paisa.in/pwaspot/', //uat
    userID: 'ZyT47UW2g56',
    password: 'H98qlU4Sn2',
    baseAPI: ' https://diygateway.5paisa.com/pwaspot/',//live
    //UAt
    // baseModificationAPI: 'https://gateway.5paisa.in/ModificationAPI/',
    // gateWayModificationKey: 'f826c701af874507967c537de48bd25c',
    //live
    baseModificationAPI: 'https://diygateway.5paisa.com/emodify/',
    gateWayModificationKey: 'aab80caef8ff4d0691009824c5d3d29c',

    baseAPIActivation: 'https://gateway.5paisa.in/5peaccountuat/',
    geoLocationUrl: 'https://api.ipgeolocation.io/ipgeo', //uat
    //geoLocationUrl: 'https://website.5paisa.com/WebApps/ipgeo?apiKey=d7a00180faa14d5b89906d9710e6bfdd',//Live
    ipoGatewayKey: '3694a376dc514d3388a22372eced4988',
    loginUrl : 'https://login.5paisa.com',
    salarysegmentKye  : "kahdAjhfdsd423jkoi3frDFD3vbxvzyXZ4S4dF",
    tradeapi_GatewayKey: 'a8ed3b7ead504fa8903d9c7e0d23bc61',
    tradeapi_url : "https://gateway.5paisa.com/tradeapi/",
    //kyc_Url: 'https://kycapi.5paisa.com/',
   kyc_Url: 'https://kycapi.5paisa.com/',
    auth_generate_key:
      'Basic NXBhaXNhX2t5Y19iYWNrZW5kX3Byb2Q6NXAta3ljQDE5MDFfcHJvZF92MQ==',
    authKey:
      'Basic ZXlKaGJHY2lPaUpJVXpJMU5pSjkuZXlKemRXSWlPaUphWVhaUmFXTnBZVUkxYm5OaFVrMU5ZV1U0TlVrMlJtTmFVVWcyY0VWc1YwSnhXRXhOT1dOaVJVRjNQU0lzSW1saGRDSTZMVGN3TmpNek9UZ3dNSDAucjRkLXFCblhiRFpxTTZCSVIzclNEVUZGUTcwWHJoWVVfdWZQTG5NeVFpMDpleUpoYkdjaU9pSklVekkxTmlKOS5leUp6ZFdJaU9pSmFNRnBsVVRkQ1dHeFNVVEpqWVUxNlpUZHhjMjFzY1N0MFkzRTRVelZqZUZGS1RWQnRXbUZEWVZORlBTSXNJbWxoZENJNkxUY3dOak16T1Rnd01IMC4zdHQ0Z0huczl4QUZuakRBTERPQWhiVEhoUElZTGJ2Ym5lMU9xN3ZBY2tR',
    ipgeo_Key: 'd7a00180faa14d5b89906d9710e6bfdd',
    diygateway_url: 'https://diygateway.5paisa.com/5peaccount/',
    eaccount_GatewayKey: 'a005f813e8a44ff9b8b45c61583b3820',
    microChartHeaderKey: '2284d4215515451ca7266097726d8097',
    temp1 : 'e5a8b69d9994693a07a538cac4c7c1a3b0591bb9',
    domainUrl : '?ReturnUrl=https://modification.5paisa.com/'

    //added variables
};
